import { FileExtensions } from '../file.model';

export enum FileTableColumnNames {
    NAME = 'NAME',
    SIZE = 'SIZE',
    REMOVE = 'REMOVE'
}

export const DefaultFileExtensions = [
    FileExtensions.jpeg,
    FileExtensions.jpg,
    FileExtensions.png,
    FileExtensions.gif,
    FileExtensions.bmp,
    FileExtensions.docx,
    FileExtensions.doc,
    FileExtensions.pdf
];
